import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    background: ${theme.palette.neutral[50]};
    display: flex;
    justify-content: center;

    padding: ${theme.layout.spacing(3)};

    flex: 1;

    main {
      width: 100%;
      max-width: ${theme.layout.breakpoints.lg};
      flex: 1;

      display: flex;
      flex-direction: column;

      gap: ${theme.layout.spacing(3)};

      footer {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        gap: ${theme.layout.spacing(2)};

        caption {
          font-size: ${theme.typography.sizes.caption};
          color: ${theme.palette.text.light};
        }
      }
    }

    @media (min-width: ${theme.layout.breakpoints.md}) {
      main footer > button {
        width: 400px;
        align-self: center;
      }
    }
  `}
`;

export const DataSection = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.layout.spacing(1.5)};

    h3 {
      font-size: ${theme.typography.sizes.title3};
      font-weight: ${theme.typography.weight.bold};
    }

    > div {
      display: flex;
      flex-direction: column;
      padding: ${theme.layout.spacing(2)};
      gap: ${theme.layout.spacing(2)};

      border: 1px solid ${theme.palette.neutral[200]};
      border-radius: 1.5rem;

      .row {
        display: flex;
        flex-direction: column;
        gap: ${theme.layout.spacing(2)};

        .item {
          display: flex;
          flex-direction: column;
          gap: ${theme.layout.spacing(1)};

          strong {
            font-size: ${theme.typography.sizes.body1};
            font-weight: ${theme.typography.weight.bold};
            color: ${theme.palette.text.light};
          }

          span {
            font-size: ${theme.typography.sizes.body1};
            font-weight: ${theme.typography.weight.regular};
          }
        }
      }
    }

    @media (min-width: ${theme.layout.breakpoints.md}) {
      > div .row {
        flex-direction: initial;

        .item {
          flex: 1;
        }
      }
    }
  `}
`;
